import And from "./query-and.js";
import Or from "./query-or.js";
import { AllowAll } from "./allow-all.js";
import DenyAll from "./deny-all.js";
import Not from "./query-not.js";

export default {
	And,
	Or,
	Not,
	DenyAll,
	AllowAll,
};
